import type { HttpAdapter } from "../core/adapters/axios.adapter"
import type { NewsDO } from "./news.data"

export class NewsService {
  constructor(private newsAdapter: HttpAdapter) { }

  async load(keywords?: string | null, minScore?: string | null): Promise<NewsDO[]> {
    const params = new URLSearchParams()

    if (keywords) params.set('keywords', keywords)
    if (minScore) params.set('minScore', minScore)

    const response = await this.newsAdapter.get<NewsDO[]>(`?${params}`);
    // const response = await this.newsAdapter.get<NewsDO[]>('')
    return response.data;
  }
}
